import { defaultFont } from './material-kit-react.js';
import tooltip from './tooltipsStyle.js';

const headerLinksStyle = (theme) => ({
  list: {
    ...defaultFont,
    alignItems: 'center',
    color: 'inherit',
    display: 'flex',
    fontSize: '14px',
    gap: '2px',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: 0,
      width: '100%'
    }
  },
  listItem: {
    color: 'inherit',
    display: 'flex',
    margin: 0,
    padding: 0,
    position: 'relative',
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      borderBottom: '1px solid rgba(255,255,255,0.09)',
      padding: '6px 0',
      width: '100%'
    }
  },
  navLink: {
    alignItems: 'center',
    borderRadius: '11px',
    color: 'rgba(255,255,255,0.78) !important',
    display: 'inline-flex',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '20px',
    margin: 0,
    minWidth: 0,
    padding: '10px 11px !important',
    textDecoration: 'none',
    textTransform: 'none',
    transition: 'background-color 180ms ease, color 180ms ease',
    '&:hover,&:focus': {
      backgroundColor: 'rgba(255,255,255,0.08) !important',
      color: '#FFFFFF !important'
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: '13px',
      justifyContent: 'flex-start',
      minHeight: '50px',
      padding: '12px 13px !important',
      width: '100%'
    }
  },
  navLabel: {
    fontSize: '0.78rem !important',
    fontWeight: '750 !important',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.94rem !important'
    }
  },
  navIcon: {
    alignItems: 'center',
    color: '#B7EE00',
    display: 'none',
    marginRight: '12px',
    '& svg': {
      fontSize: '21px'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'inline-flex'
    }
  },
  socialListItem: {
    marginLeft: '5px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      padding: '14px 12px'
    }
  },
  socialGroup: {
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.065)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '13px',
    display: 'flex',
    gap: '2px',
    padding: '3px',
    [theme.breakpoints.down('sm')]: {
      width: 'fit-content'
    }
  },
  socialLink: {
    alignItems: 'center',
    borderRadius: '9px !important',
    color: 'rgba(255,255,255,0.75) !important',
    display: 'inline-flex',
    height: '34px',
    justifyContent: 'center',
    margin: '0 !important',
    minWidth: '34px !important',
    padding: '0 !important',
    width: '34px',
    '&:hover,&:focus': {
      backgroundColor: '#B7EE00 !important',
      color: '#111411 !important'
    }
  },
  socialIcons: {
    fontSize: '14px !important',
    lineHeight: 1
  },
  languageListItem: {
    marginLeft: '4px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      padding: '14px 12px'
    }
  },
  languageControl: {
    minWidth: '104px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  toggleDropdown: {
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '11px',
    color: '#FFFFFF',
    cursor: 'pointer',
    display: 'flex',
    fontFamily: 'inherit',
    fontSize: '0.76rem',
    fontWeight: 750,
    height: '42px',
    justifyContent: 'space-between',
    padding: '0 9px 0 12px',
    width: '100%',
    '&:hover,&:focus': {
      backgroundColor: 'rgba(255,255,255,0.12)',
      outline: 'none'
    }
  },
  dropdownIcon: {
    fontSize: '20px !important',
    transition: 'transform 180ms ease'
  },
  dropdownIconActive: {
    fontSize: '20px !important',
    transform: 'rotate(180deg)',
    transition: 'transform 180ms ease'
  },
  optionUl: {
    backgroundColor: '#FFFFFF',
    border: '1px solid rgba(17,20,17,0.1)',
    borderRadius: '12px',
    boxShadow: '0 18px 40px rgba(0,0,0,0.22)',
    display: 'none',
    listStyle: 'none',
    margin: '8px 0 0',
    minWidth: '100%',
    padding: '6px',
    position: 'absolute',
    right: 0,
    top: '100%',
    zIndex: 3000,
    [theme.breakpoints.down('sm')]: {
      left: 0,
      right: 'auto'
    }
  },
  optionUlActive: {
    display: 'block'
  },
  option: {
    borderRadius: '8px',
    color: '#111411',
    cursor: 'pointer',
    fontSize: '0.78rem',
    fontWeight: 700,
    padding: '9px 10px',
    whiteSpace: 'nowrap',
    '&:hover,&:focus': {
      backgroundColor: '#EFF4E8'
    }
  },
  ...tooltip
});

export default headerLinksStyle;
